import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'
import Qs from 'qs'

const validatebillinginfo = async ($organizationId, $data) =>
  await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/validatebillinginfo`, $data)

const createpaymentintent = async ($organizationId, $data) =>
  await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/createpaymentintent`, $data)

const confirmpaymentintent = async ($organizationId, $data) =>
  await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/ConfirmPaymentIntent`, $data)

const stripePaymentIntentId = async ($organizationId, $stripePaymentIntentId) =>
  await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT}/${$organizationId}/paymentintent${$stripePaymentIntentId}`)

const editPaymentMethod = async ($organizationId, $secretId) =>
  await axiosInstance.post(`${SERVICES.BALANCE_PAYMENT_METHOD}/${$organizationId}/edit/${$secretId}`)

const getReasonsToCancel = async () => await axiosInstance.get(`${SERVICES.BALANCE_PLAN_CANCELATION_REASON}`)

const cancelOrganizationPlan = async ($organizationId, $data) =>
  await axiosInstance.delete(`${SERVICES.BALANCE_ORGANIZATION_PLANS}/${$organizationId}`, { data: $data }) // atualizando

const getOverview = async ($organizationId) => await axiosInstance.get(`${SERVICES.BALANCE_ORGANIZATION_PLANS}/${$organizationId}/overview`)

const getInvoices = async ($organizationId, $params) =>
  await axiosInstance.get(`${SERVICES.BALANCE_INVOICES}/${$organizationId}`, {
    params: $params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })

const cancelAddonEmail = async ($organizationId, $addRecurrentId) =>
  axiosInstance.delete(`${SERVICES.BALANCE_ADDORECURRENTEMAIL}/${$organizationId}/${$addRecurrentId}`)

const cancelAddonSMS = async ($organizationId, $addRecurrentId) =>
  axiosInstance.delete(`${SERVICES.BALANCE_ADDORECURRENTSMS}/${$organizationId}/${$addRecurrentId}`)

export default {
  validatebillinginfo,
  createpaymentintent,
  confirmpaymentintent,
  stripePaymentIntentId,
  editPaymentMethod,
  getReasonsToCancel,
  cancelOrganizationPlan,
  getOverview,
  getInvoices,
  cancelAddonEmail,
  cancelAddonSMS,
}
